import script from "./CaskDialogUploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskDialogUploadFile.vue?vue&type=script&setup=true&lang=js"

import "./CaskDialogUploadFile.vue?vue&type=style&index=0&id=9b697dbc&lang=scss"
import "./CaskDialogUploadFile.vue?vue&type=style&index=1&id=9b697dbc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b697dbc"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QSeparator,QBtn,QSpinnerIos});
